import { InstrumentName } from "../types/sound";

/**
 * Maps instrument identifiers to human-readable display labels
 */
export const INSTRUMENT_LABELS: Record<InstrumentName, string> = {
    "cello": "Cello",
    "e-piano": "Electric Piano",
    "harp": "Harp",
    "piano": "Piano",
    "saw-synth": "Saw Synth",
    "sine-synth": "Sine Synth",
    "square-synth": "Square Synth",
    "viola": "Viola",
};

/**
 * Gets the display label for an instrument
 * @param instrument - The instrument identifier
 * @returns The human-readable label
 */
export function getInstrumentLabel(instrument: InstrumentName): string {
    return INSTRUMENT_LABELS[instrument];
}
